export default __webpack_public_path__ + "static/media/hero-dtMedium.232b207c.jpg";